import { OverlayView, OverlayViewF } from '@react-google-maps/api'
import { useMemo } from 'react'
import { getPixelPositionMarker } from '../map/map.helper'

export default function MapStaticLocation({
	latitude,
	longitude,
}: {
	latitude: number
	longitude: number
}) {
	const memoMarker = useMemo(() => {
		const renderMarker = () => (
			<span className="relative flex h-6 w-6 items-center justify-center">
				<span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-secondary opacity-75"></span>
				<span className="relative inline-flex h-4 w-4 rounded-full bg-secondary"></span>
			</span>
		)
		return (
			<OverlayViewF
				position={{ lat: latitude, lng: longitude }}
				mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
				getPixelPositionOffset={getPixelPositionMarker}
				zIndex={30}
			>
				{renderMarker()}
			</OverlayViewF>
		)
	}, [latitude, longitude])
	return memoMarker
}
